import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
import axios from "axios";
import ScrollToTop from './ScrollToTop';


const Footer = () => {

  const [email, setEmail] = useState("");
  const [alert, setAlert] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);

    try {
      await axios.post("https://admin.smartedung.com/#/ebun/v3/website/email", { email });
      setAlert("✅ Subscription successful!");
      setEmail("");
    } catch (err) {
      console.error(err);
      setAlert("❌ Something went wrong, please try again.");
    } finally {
      setLoading(false);
    }
  };

    useEffect(() => {
      const scrollBtn = document.querySelector(".btn-scroll-top");
  
      const handleScroll = () => {
        if (window.scrollY > 200) {
          scrollBtn.classList.add("active-progress");
        } else {
          scrollBtn.classList.remove("active-progress");
        }
      };
  
      window.addEventListener("scroll", handleScroll);
  
      return () => window.removeEventListener("scroll", handleScroll);
    }, []);
  
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    };

  return (
    <>
      <div className="btn-scroll-top" onClick={scrollToTop}>
        <svg
          className="progress-square svg-content"
          width="100%"
          height="100%"
          viewBox="0 0 40 40"
        >
          <path d="M8 1H32C35.866 1 39 4.13401 39 8V32C39 35.866 35.866 39 32 39H8C4.13401 39 1 35.866 1 32V8C1 4.13401 4.13401 1 8 1Z" />
        </svg>
      </div>

      <section
        className="py-2 bg-primary position-relative"
        style={{
          backgroundImage: "url('../../assets/images/background/spiral.svg')",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container-fluid px-4 px-lg-4 mt-lg-4 mt-4">

          {/* Top Text */}
          <div className="col-12 pt-lg-6 text-center text-lg-start">
            <div className="fs-2 fw-semibold text-dark mb-3">
              Dope Things Only ✌🏽{" "}
              <span className="text-dark fw-medium fs-5">
                Follow Our Social Media Handles
              </span>
            </div>
          </div>

          <div className="row align-items-center pt-lg-0">

            {/* Contact Section */}
            <div className="col-lg-5 text-center text-lg-start mt-4 mt-lg-0">
              <div className="pt-lg-8 pt-4 px-lg-6">

                <div className="fs-t text-dark fw-bold">
                  Have questions?
                </div>

                <div className="d-flex gap-3 pt-4 text-start">
                  <div className="fs-3 text-dark">
                    <i className="bi bi-geo-alt"></i>
                  </div>
                  <div className="fs-4 text-dark fw-medium">
                    <div className="mb-3">
                      101, Liasu Road, Egbe-Idimu, Lagos.
                    </div>
                    <div className="mb-3">
                      18, Imaam Saliu Str., Off Afolabi B/Stop, Akesan Lagos.
                    </div>
                    <div className="mb-3">
                      22, Tolu Aluko Str., Off Liasu Rd, Council-Idimu, Lagos.
                    </div>
                  </div>
                </div>

                <div className="d-flex gap-3 pt-4 text-start">
                  <div className="fs-3 text-dark">
                    <i className="bi bi-telephone-fill"></i>
                  </div>
                  <div className="fs-4 text-dark fw-medium">
                    <div className="mb-3">+234 809 754 8759</div>
                    <div className="mb-3">+234 802 331 3735</div>
                    <div className="mb-3">+234 803 372 8705</div>
                  </div>
                </div>

                <div className="d-flex gap-3 pt-4 text-start">
                  <div className="fs-3 text-dark">
                    <i className="bi bi-envelope"></i>
                  </div>
                  <div className="fs-4 text-dark fw-medium">
                    admin@ebunheritageschool.com
                  </div>
                </div>

              </div>
            </div>

            {/* About Section */}
            <div className="col-lg-4 text-center text-lg-start mt-4 mt-lg-8 px-lg-8">

              <div className="mb-4">
                <div className="fs-t text-dark fw-bold">
                  Know about us.
                </div>
              </div>

              <div className="fs-4 fw-medium">
                <div className="mb-3">
                  <Link to="/about" className="text-dark link-hover">About Us</Link>
                </div>
                <div className="mb-3">
                  <Link to="/creche" className="text-dark link-hover">Creche & Pre-School</Link>
                </div>
                <div className="mb-3">
                  <Link to="/primary" className="text-dark link-hover">Primary School</Link>
                </div>
                <div className="mb-3">
                  <Link to="/secondary" className="text-dark link-hover">Secondary School</Link>
                </div>
                <div className="mb-3">
                  <Link to="/special-need" className="text-dark link-hover">Special Need School</Link>
                </div>
                <div className="mb-3">
                  <Link to="/entrance-form" className="text-dark link-hover">Entrance Form</Link>
                </div>
                <div className="mb-3">
                  <Link to="/privacy-policy" className="text-dark link-hover">Privacy Policy</Link>
                </div>
              </div>

            </div>

            {/* Social Section */}
            <div className="col-lg-3 text-center text-lg-start mt-4 mt-lg-6">

              <div className="mb-4">
                <div className="fs-t text-dark fw-bold">
                  Connect with us!
                </div>
              </div>

              <div className="fs-3 fw-semibold">

                <div className="mb-4">
                  <a
                    href="https://www.instagram.com/ebunheriatageschools?igsh=MTI3bmMzMTJhNDZ0Ng=="
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-dark"
                  >
                    <span className="bi bi-instagram"></span> Instagram
                  </a>
                </div>

                <div className="mb-4">
                  <a
                    href="https://www.tiktok.com/@ebunheritage25?_r=1&_t=ZS-93urQXHyOhx"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-dark"
                  >
                    <span className="bi bi-tiktok"></span> Tiktok
                  </a>
                </div>

                <div className="mb-4">
                  <a
                    href="https://www.facebook.com/share/1DiKXCUp7d/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-dark"
                  >
                    <span className="bi bi-facebook"></span> Facebook
                  </a>
                </div>

                <div className="mb-4">
                  <a
                    href="https://www.youtube.com/channel/UCLizdFxOQ8vKTzn4VJu7UvA"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-dark"
                  >
                    <span className="bi bi-youtube"></span> YouTube
                  </a>
                </div>

              </div>
            </div>

            {/* Copyright */}
            <div className="col-12 text-center mt-6">
              <div className="fs-4 text-dark">
                Copyright © {new Date().getFullYear()} All rights reserved | Powered by Smart Edu Inc.
              </div>
            </div>

          </div>
        </div>
      </section>

      <ScrollToTop />
    </>
  );
};

export default Footer;
